import React from 'react';
import DataTable from "../../components/data-table/DataTable";
import {getEmployees, navLinks} from "../../services/organization";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import SearchField from "../../components/fields/SearchField";
import ActionButton from "../../components/button/ActionButton";

const columnData = [
    { id: 'name', numeric: false, disablePadding: false, label: 'ФИО' },
    { id: 'employeeStatusText', numeric: false, disablePadding: false, label: 'Статус' },
    { id: 'employeePostText', numeric: false, disablePadding: false, label: 'Должность' },
    { id: 'departmentName', numeric: false, disablePadding: false, label: 'Подразделение' },
    { id: 'mainBusinessUnit.name', label: 'Основной БЮ'},
    { id: 'parlourNameText', numeric: false, disablePadding: false, label: 'Работает в БЮ' },
];

class MasterListPage extends React.Component {

    state = {
        search: {
            search: null
        },
        refreshTable: false
    };

    handleChange = prop => event => {
        this.setState({
            search: {
                ...this.state.search,
                [prop]: event.target.value,
            }
        });
    };

    handleClickSearch = () => {
        this.setState(state => ({ refreshTable: !state.refreshTable }));
    };

    handleAdd = () => {
        this.props.history.push(`/organization/masters/view/0`);
    };

    getTableData = (...params) => {
        const {search} = this.state;
        return getEmployees(search, ...params);
    };

    render() {
        const { search, refreshTable } = this.state;

        return (
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                    <SearchField
                        value={search.search}
                        onChange={this.handleChange('search')}
                        onClick={this.handleClickSearch}
                        label="Поиск"
                    />
                    <br />
                    <br />
                    <ActionButton onClick={this.handleAdd}>Добавить</ActionButton>
                </LeftBar>
                <Content title="Сотрудники">
                    <DataTable
                        columnData={columnData}
                        dataFunc={this.getTableData}
                        linkTemplate={(item) => `/organization/masters/view/${item.id}`}
                        selector={false}
                        refresh={refreshTable}
                    />
                </Content>
            </React.Fragment>
        );
    }
}

export default MasterListPage;
